import { Component } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html'
})
export class AlertDialogComponent {

  header: string = 'Drift Email Alert';
  message: string = '';
  confirmBtn: string = 'OK';
  moreInfoToggle: boolean = false;
  moreInfoText: string = '';

  constructor(public modal: BsModalRef) { }

  toggleInfo() {
    this.moreInfoToggle = !this.moreInfoToggle;
  }
}



// WEBPACK FOOTER //
// ./client/app/global/alert-dialog/alert-dialog.component.ts